// removed by extract-text-webpack-plugin
module.exports = {"component":"_7CKNlj8LOecCTofgNVNuA"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Cart/Templates/Widget/theme.css
// module id = 1259
// module chunks = 2